export type CourseBreakerMark = "C" | "U" | "L" | "I";

export type CourseBreakerNode = {
  id: string;
  kind: "course" | "container" | "item";
  mark: CourseBreakerMark;
  label: string;
  title: string;
  questionCount: number;
  children: CourseBreakerNode[];
};

export type CourseBreakerTree = {
  courseId: string;
  courseTitle: string;
  roots: CourseBreakerNode[];
};

type ItemLike = {
  id: string;
  label: string;
  title: string | null;
  questionCount?: number;
};

type ContainerLike = {
  id: string;
  type: string;
  label: string;
  typeLabel: string;
  title: string | null;
  children: ContainerLike[];
  activities: ItemLike[];
};

export function courseBreakerQueryOn(search: string) {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  if (params.has("CourseBreaker")) {
    const value = (params.get("CourseBreaker") || "").trim().toLowerCase();
    return value === "" || value === "true" || value === "1";
  }
  return params.get("allow_deletion") === "true";
}

export function treeFromCourseStructure(structure: {
  course: { id: string; title: string };
  containers: ContainerLike[];
  activities: ItemLike[];
}): CourseBreakerTree {
  const itemNode = (item: ItemLike): CourseBreakerNode => ({
    id: item.id,
    kind: "item",
    mark: "I",
    label: item.label,
    title: item.title?.trim() || item.label,
    questionCount: Number(item.questionCount || 0),
    children: [],
  });
  const containerNode = (node: ContainerLike): CourseBreakerNode => ({
    id: node.id,
    kind: "container",
    mark: node.type === "lesson" ? "L" : "U",
    label: node.label,
    title: node.title?.trim() || `Untitled ${node.typeLabel}`,
    questionCount: 0,
    children: [...node.children.map(containerNode), ...node.activities.map(itemNode)],
  });
  return {
    courseId: structure.course.id,
    courseTitle: structure.course.title || "This course",
    roots: [
      {
        id: structure.course.id,
        kind: "course",
        mark: "C",
        label: "Course",
        title: structure.course.title || "This course",
        questionCount: 0,
        children: [...structure.containers.map(containerNode), ...structure.activities.map(itemNode)],
      },
    ],
  };
}
